import { Route, Routes } from 'react-router-dom';

import { App } from './App';

import { ProtectedRoute } from './MainMenu/CoreAndIntegration/Components/Login/ProtectedRoute';
import { AuthenticationScreen } from './MainMenu/CoreAndIntegration/Components/Login/AuthenticationScreen';

import { LeadAndCustomerRouting } from './MainMenu/LeadAndCustomer/LeadAndCustomerRouting';
import { WorkspaceRouting } from "./MainMenu/Workspace/WorkspaceRouting";
import { BillingRouting } from "./MainMenu/Billing/BillingRouting";

import PaymentForm from './MainMenu/Billing/Components/invoice-generation-engine/PaymentForm';
import { BookingCalendar } from './MainMenu/Workspace/Components/bookingCalendar';
import { AssignmentForm } from './MainMenu/Workspace/Components/assignmentForm';
import { UserTable } from './MainMenu/CoreAndIntegration/Components/User/ShowAllUsers';
import { SendEmail } from './MainMenu/CoreAndIntegration/Components/SendEmail/SendEmail';
import { EmailTemplateTable } from './MainMenu/CoreAndIntegration/Components/EmailTemplate/ShowAllEmailTemplates';
import AuditLogTable from './MainMenu/CoreAndIntegration/Components/User/AuditLogTable';
import { RegisterUser } from './MainMenu/CoreAndIntegration/Components/Login/registerUser';
import { UpdateBooking } from './MainMenu/Workspace/Components/updateBooking';
import { Report } from './MainMenu/Workspace/Components/report';
import { UpdateAssigenment } from './MainMenu/Workspace/Components/updateAssigenment';
import DocumentUpload from './MainMenu/CoreAndIntegration/Components/DocumentUpload';
import { CustomerChange } from './MainMenu/Workspace/Components/customerChange';
import DocumentTemplate from './MainMenu/DocumentManagement/Components/DocumentTemplate';
import { UpdateDocumentTemplate } from './MainMenu/DocumentManagement/Components/UpdateDocumentTemplate';
import { ShowDocumentTemplate } from './MainMenu/DocumentManagement/Components/ShowDocumentTemplate';
import AddDocumentTemplate from './MainMenu/DocumentManagement/Components/AddDocumentTemplate';
import { DocumentTemplatePreviewPage } from './MainMenu/DocumentManagement/Components/DocumentTempExport';
import { FinancialReportsDashboard } from './MainMenu/Billing/Components/FinancialReports/FinancialReportsDashboard';

/* eslint-disable react/jsx-no-comment-textnodes */
export const Routing = () => {
    return (
        <Routes>
            <Route path="auth" element={ <AuthenticationScreen/> }/>
            <Route path="" element={
                <ProtectedRoute>
                    <App/>
                </ProtectedRoute>
            }>
                // לקוחות
                <Route path="leadAndCustomer/*" element={ <LeadAndCustomerRouting/> }/>

                // חללים
                <Route path="workspace/*" element={ <WorkspaceRouting/> }/>

                // כספים
                <Route path="billing/*" element={ <BillingRouting/> }/>

                // דוחות
                <Route path="/occupancyReports" element={ <Report/> }/>
                <Route path="/billing/financeReports" element={ <FinancialReportsDashboard/> }/>

                // ניהול משתמשים
                <Route path="users" element={ < UserTable/> }/>
                <Route path="/registerUser" element={ <RegisterUser/> }/>
                <Route path="UserActions" element={ < AuditLogTable/> }/>
                <Route path="/documentUpload" element={ < DocumentUpload/> }/>

                <Route path="assignmentForm" element={ <AssignmentForm/> }/>
                <Route path="updateAssignment" element={ <UpdateAssigenment/> }/>
                <Route path="updateBooking" element={ <UpdateBooking/> }/>
                <Route path="payment-form" element={ <PaymentForm/> }/>

                <Route path="assignmentForm" element={ <AssignmentForm/> }/>
                <Route path="bookingCalendar" element={ <BookingCalendar roomId={ "" } roomName={ "" }/> }/>
                <Route path="payments" element={ <DocumentTemplate/> }/>
                <Route path="/document-templates" element={ <DocumentTemplate/> }/>
                <Route path="document-templates/edit/:id" element={ <UpdateDocumentTemplate/> }/>
                <Route path="document-templates/view/:id" element={ <ShowDocumentTemplate/> }/>
                <Route path="document-templates/preview/:id" element={ <DocumentTemplatePreviewPage/> }/>
                <Route path="document-templates/add" element={ <AddDocumentTemplate/> }/>
                {/* <Route path="document-templates/preview/:id" element={<DocumentTemplate />} /> */ }
                <Route path="payment" element={ <PaymentForm/> }/>

                <Route path="emailTemplate" element={ < EmailTemplateTable/> }/>
                <Route path="sendEmails" element={ < SendEmail/> }/>

                <Route path="/customerChange" element={ <CustomerChange/> }/>
            </Route>

            <Route path="*" element={ <div>404 - page not found</div> }/>
        </Routes>
    );
};